import {REAL_TIME} from '../actions';

export default function realTime(state = false, action) {
  switch (action.type) {
    case REAL_TIME:
      return action.status;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/realTime.js